export const PATH_COLORS = [
  { dot: 'bg-green-500', text: 'text-green-500', border: 'border-green-400' },
  { dot: 'bg-blue-500', text: 'text-blue-500', border: 'border-blue-400' },
  { dot: 'bg-purple-500', text: 'text-purple-500', border: 'border-purple-400' },
  { dot: 'bg-yellow-500', text: 'text-yellow-500', border: 'border-yellow-400' },
  { dot: 'bg-pink-500', text: 'text-pink-500', border: 'border-pink-400' },
  { dot: 'bg-indigo-500', text: 'text-indigo-500', border: 'border-indigo-400' },
  { dot: 'bg-orange-500', text: 'text-orange-500', border: 'border-orange-400' },
  { dot: 'bg-teal-500', text: 'text-teal-500', border: 'border-teal-400' },
  { dot: 'bg-red-500', text: 'text-red-500', border: 'border-red-400' },
  { dot: 'bg-cyan-500', text: 'text-cyan-500', border: 'border-cyan-400' },
]
